// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"3800":"146261ef","7150":"32006cf2","7606":"c80e4dbd","9861":"3199c74f"}[chunkId] + ".chunk.css";
};